import * as React from "react";
import { SVGUniqueID } from "react-svg-unique-id";

export const Facebook = () => (
  <SVGUniqueID>
    <svg width="36px" height="36px" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.768 15.737H12v3.315h3.768V29h4.422v-9.948h4.42v-3.315h-4.42v-1.335c0-1.002 1.053-3.087 2.589-3.087h1.831V8h-3.868c-5.457.795-4.974 7.737-4.974 7.737z"
        fill="currentColor"
      ></path>
    </svg>
  </SVGUniqueID>
);

export const Instagram = () => (
  <SVGUniqueID>
    <svg width="36px" height="36px" xmlns="http://www.w3.org/2000/svg">
      <g fill="currentColor">
        <path d="M18 10.621c2.403 0 2.688.01 3.637.053.877.04 1.354.188 1.671.31.42.162.72.359 1.035.672.316.316.51.615.672 1.035.123.318.27.795.311 1.673.043.948.052 1.233.052 3.636s-.009 2.688-.052 3.637c-.04.878-.186 1.354-.31 1.671a2.8 2.8 0 01-.674 1.035c-.315.316-.615.51-1.035.672-.315.125-.792.27-1.67.311-.949.043-1.234.052-3.637.052s-2.688-.009-3.637-.052c-.877-.04-1.354-.186-1.671-.31a2.787 2.787 0 01-1.036-.672 2.771 2.771 0 01-.671-1.036c-.125-.317-.27-.794-.311-1.67-.043-.95-.053-1.235-.053-3.638 0-2.403.01-2.688.053-3.637.04-.877.188-1.354.31-1.671.162-.42.359-.72.672-1.036.316-.315.615-.51 1.035-.671.318-.125.795-.27 1.673-.311.948-.043 1.233-.053 3.636-.053zM18 9c-2.445 0-2.751.01-3.711.054-.957.045-1.612.195-2.184.418a4.385 4.385 0 00-1.595 1.039 4.417 4.417 0 00-1.037 1.594c-.223.572-.376 1.227-.419 2.184C9.009 15.249 9 15.557 9 18c0 2.444.01 2.751.054 3.711.045.957.195 1.613.418 2.184.23.593.537 1.095 1.039 1.595a4.398 4.398 0 001.594 1.038c.572.222 1.227.375 2.184.418.96.045 1.268.054 3.711.054 2.444 0 2.751-.01 3.711-.054.957-.045 1.613-.195 2.184-.419a4.385 4.385 0 001.595-1.038 4.398 4.398 0 001.038-1.594c.222-.572.375-1.227.418-2.184.045-.96.054-1.267.054-3.711s-.01-2.751-.054-3.711c-.045-.957-.195-1.612-.419-2.184a4.412 4.412 0 00-1.038-1.595 4.41 4.41 0 00-1.594-1.037c-.572-.223-1.227-.376-2.184-.419C20.751 9.009 20.444 9 18 9z"></path>
        <path d="M18 13.379a4.622 4.622 0 100 9.243 4.622 4.622 0 000-9.243zM18 21a3 3 0 110-6 3 3 0 010 6z"></path>
        <circle cx="22.805" cy="13.195" r="1.08"></circle>
      </g>
    </svg>
  </SVGUniqueID>
);

export const Youtube = () => (
  <SVGUniqueID>
    <svg width="36px" height="36px" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.79 13.58s-.206-1.448-.834-2.085c-.8-.837-1.695-.84-2.104-.89-2.94-.213-7.348-.213-7.348-.213h-.009s-4.408 0-7.347.213c-.41.05-1.304.053-2.104.89-.63.637-.834 2.085-.834 2.085S8 15.276 8 16.976v1.595c0 1.698.21 3.397.21 3.397s.205 1.447.834 2.085c.8.837 1.848.81 2.316.897 1.68.162 7.14.212 7.14.212s4.413-.006 7.35-.22c.412-.049 1.306-.053 2.106-.889.63-.637.834-2.085.834-2.085s.21-1.7.21-3.399v-1.593a31.8 31.8 0 00-.21-3.398zm-12.457 6.922l-.002-5.901 5.675 2.961-5.674 2.94z"
        fill="currentColor"
      ></path>
    </svg>
  </SVGUniqueID>
);

export const Twitter = () => (
  <SVGUniqueID>
    <svg width="36px" height="36px" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.55 12.364c.982.177 1.993.12 2.95-.165a11.638 11.638 0 00-3.01 2.183 11.31 11.31 0 01-9.144 11.903 14.601 14.601 0 01-8.846-2.36s3.933 1.062 6.104-1.34c0 0-3.696.337-4.581-2.52a11.242 11.242 0 002.58-.364 4.197 4.197 0 01-3.413-4.115 4.05 4.05 0 001.928.515s-2.857-2.58-1.087-5.607c0 0 3.829 4.675 8.571 4.407a4.077 4.077 0 016.855-3.871 6.393 6.393 0 002.773-1.335 3.547 3.547 0 01-1.68 2.67z"
        fill="currentColor"
      ></path>
    </svg>
  </SVGUniqueID>
);

export const Pinterest = () => (
  <SVGUniqueID>
    <svg width="36px" height="36px" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.492 7.5c-5.73 0-8.62 4.11-8.62 7.536 0 2.075.786 3.92 2.47 4.608.276.113.524.003.603-.303.056-.21.188-.745.248-.967.079-.303.048-.408-.175-.672-.486-.573-.795-1.316-.795-2.366 0-3.048 2.28-5.778 5.937-5.778 3.24 0 5.02 1.98 5.02 4.623 0 3.479-1.54 6.414-3.825 6.414-1.26 0-2.206-1.044-1.902-2.325.361-1.527 1.064-3.175 1.064-4.28 0-.986-.53-1.81-1.627-1.81-1.29 0-2.325 1.335-2.325 3.122 0 1.14.384 1.91.384 1.91l-1.554 6.572c-.46 1.95-.069 4.343-.036 4.584.02.143.204.177.287.07.12-.157 1.655-2.054 2.177-3.949.149-.537.85-3.315.85-3.315.42.8 1.644 1.503 2.946 1.503 3.877 0 6.51-3.535 6.51-8.266-.002-3.58-3.032-6.91-7.639-6.91h.002z"
        fill="currentColor"
      ></path>
    </svg>
  </SVGUniqueID>
);

export const Arrow = () => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
    >
      <path
        id="arrow_up"
        d="M11.249,8.581v10h2.087v-10l4.481,4.481,1.476-1.476-7-7-7,7,1.476,1.476Z"
        transform="translate(-5.293 -4.586)"
        fill="#c1cace"
      />
    </svg>
  </SVGUniqueID>
);

export const ShareButton = () => (
  <SVGUniqueID>
    <svg width="56" height="56" viewBox="0 0 56 56">
      <g
        id="Componente_24_7"
        data-name="Componente 24 – 7"
        transform="translate(1.5 1.5)"
      >
        <g id="Grupo_7588" data-name="Grupo 7588">
          <g
            transform="matrix(1, 0, 0, 1, -1.5, -1.5)"
            filter="url(#Elipse_94)"
          >
            <circle
              id="Elipse_94-2"
              data-name="Elipse 94"
              cx="26"
              cy="26"
              r="26"
              transform="translate(1.5 1.5)"
              fill="#fff"
            />
          </g>
          <path
            id="Trazado_11802"
            data-name="Trazado 11802"
            d="M1559.206,362.193a7.005,7.005,0,0,0-5.642,2.823l-7.82-4.231a6.238,6.238,0,0,0-.006-4.753l7.455-4.245a6.961,6.961,0,0,0,6.013,3.414,6.716,6.716,0,1,0-6.948-6.712,6.479,6.479,0,0,0,.162,1.413l-7.715,4.393a7,7,0,0,0-5.441-2.589,6.717,6.717,0,1,0,0,13.425,7,7,0,0,0,5.454-2.606l7.921,4.286a6.4,6.4,0,0,0-.381,2.092,6.951,6.951,0,1,0,6.948-6.712Zm0-18.413a4.711,4.711,0,1,1-4.873,4.709A4.8,4.8,0,0,1,1559.206,343.78Zm-19.941,19.346a4.711,4.711,0,1,1,4.873-4.709A4.8,4.8,0,0,1,1539.265,363.126Zm19.941,10.487a4.711,4.711,0,1,1,4.872-4.709A4.8,4.8,0,0,1,1559.206,373.613Z"
            transform="translate(-1524.468 -332.935)"
          />
        </g>
      </g>
    </svg>
  </SVGUniqueID>
);

export const ShareLike = () => (
  <SVGUniqueID>
    <svg
      id="Grupo_7591"
      data-name="Grupo 7591"
      xmlns="http://www.w3.org/2000/svg"
      width="38.095"
      height="38.095"
      viewBox="0 0 38.095 38.095"
    >
      <circle
        id="Elipse_95"
        data-name="Elipse 95"
        cx="19.047"
        cy="19.047"
        r="19.047"
        fill="#227aee"
      />
      <g
        id="Grupo_7591-2"
        data-name="Grupo 7591"
        transform="translate(9.672 7.785)"
      >
        <rect
          id="Rectángulo_5831"
          data-name="Rectángulo 5831"
          width="4.987"
          height="10.616"
          rx="1.018"
          transform="translate(0 7.914)"
          fill="#fff"
        />
        <path
          id="Trazado_11803"
          data-name="Trazado 11803"
          d="M1554.355,412.154H1548.1a16.883,16.883,0,0,0-.008-4.969,4.081,4.081,0,0,0-.878-1.966,1.722,1.722,0,0,0-2.118-.641,1.263,1.263,0,0,0-.269.2,1.627,1.627,0,0,0-.469,1.044,2.024,2.024,0,0,0-.008.229,15.246,15.246,0,0,0,.114,1.745,12.074,12.074,0,0,1-1.881,4.5l-.555.022a.43.43,0,0,0-.414.43v9.537a.6.6,0,0,0,.577.664h9.97a1.263,1.263,0,0,0,1.263-1.263v-.173a1.263,1.263,0,0,0-1.263-1.263h.763a1.261,1.261,0,0,0,1.262-1.262v-.175a1.262,1.262,0,0,0-1.262-1.262h.582a1.262,1.262,0,0,0,1.262-1.262v-.175a1.262,1.262,0,0,0-1.262-1.263h.851a1.262,1.262,0,0,0,1.263-1.262v-.175A1.262,1.262,0,0,0,1554.355,412.154Z"
          transform="translate(-1536.162 -404.419)"
          fill="#fff"
        />
      </g>
    </svg>
  </SVGUniqueID>
);

export const ShareFacebook = () => (
  <SVGUniqueID>
    <svg
      id="Grupo_7592"
      data-name="Grupo 7592"
      xmlns="http://www.w3.org/2000/svg"
      width="38.095"
      height="38.095"
      viewBox="0 0 38.095 38.095"
    >
      <circle
        id="Elipse_96"
        data-name="Elipse 96"
        cx="19.047"
        cy="19.047"
        r="19.047"
        fill="#227aee"
      />
      <path
        id="Trazado_11804"
        data-name="Trazado 11804"
        d="M1547.9,457.915v2.3h3.944l-.52,4.033H1547.9v10.441h-4.112V464.246h-3.411v-4.033h3.411v-3.1a5.82,5.82,0,0,1,.746-2.978,4.641,4.641,0,0,1,4.412-2.321,25.19,25.19,0,0,1,3.044.176V455.6h-1.822c-1.069,0-1.735.241-1.991.725a1.522,1.522,0,0,0-.175.4A4.166,4.166,0,0,0,1547.9,457.915Z"
        transform="translate(-1526.968 -443.472)"
        fill="#fff"
      />
    </svg>
  </SVGUniqueID>
);

export const ShareTwitter = () => (
  <SVGUniqueID>
    <svg
      id="Grupo_7593"
      data-name="Grupo 7593"
      xmlns="http://www.w3.org/2000/svg"
      width="38.095"
      height="38.095"
      viewBox="0 0 38.095 38.095"
    >
      <circle
        id="Elipse_97"
        data-name="Elipse 97"
        cx="19.047"
        cy="19.047"
        r="19.047"
        fill="#2696dd"
      />
      <path
        id="Trazado_11805"
        data-name="Trazado 11805"
        d="M1559.142,503.306a11.2,11.2,0,0,1-.982,1.2,6.888,6.888,0,0,1-1.2,1.041v.775a12.05,12.05,0,0,1-.735,3.962,12.97,12.97,0,0,1-3.634,5.349,12.484,12.484,0,0,1-14.764.98,8.794,8.794,0,0,0,1.165.062,8.651,8.651,0,0,0,4.044-1.062,9.574,9.574,0,0,0,1.245-.817,4.264,4.264,0,0,1-2.267-.695,4.5,4.5,0,0,1-1.838-2.349,6.5,6.5,0,0,0,.8.062h.675c.326-.068.49-.116.49-.143a3.347,3.347,0,0,1-.613-.164,4.69,4.69,0,0,1-1.511-.959,4.39,4.39,0,0,1-1.327-3.186,4.266,4.266,0,0,0,1.919.532v-.043a3.366,3.366,0,0,1-.855-.776,4.557,4.557,0,0,1-1.022-2.918,4.5,4.5,0,0,1,.571-2.1,13.47,13.47,0,0,0,2.918,2.613,14.807,14.807,0,0,0,4.187,1.736,15.03,15.03,0,0,0,1.919.223,4.611,4.611,0,0,1-.122-1,4.172,4.172,0,0,1,1.327-3.1,4.349,4.349,0,0,1,3.064-1.245,4.576,4.576,0,0,1,3.183,1.349,6.873,6.873,0,0,0,1-.247,9.322,9.322,0,0,0,1.755-.815,5.027,5.027,0,0,1-.938,1.675,6.28,6.28,0,0,1-.919.713V504a7.383,7.383,0,0,0,2.451-.7Z"
        transform="translate(-1527.954 -489.506)"
        fill="#fff"
      />
    </svg>
  </SVGUniqueID>
);

export const Search = () => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20.001"
      viewBox="0 0 20 20.001"
    >
      <path
        id="bx-search"
        d="M10.553,19.106a8.5,8.5,0,0,0,5.235-1.8l4.7,4.7L22,20.489l-4.7-4.7a8.543,8.543,0,1,0-6.747,3.316Zm0-14.968a6.415,6.415,0,1,1-6.415,6.415A6.421,6.421,0,0,1,10.553,4.138Z"
        transform="translate(-2 -2)"
        fill="#000000"
      />
    </svg>
  </SVGUniqueID>
);

export const Menu = () => (
  <SVGUniqueID>
    <svg
      aria-hidden="true"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M0 4h24v3H0zM0 11h18v3H0zM0 18h12v3H0z"></path>
    </svg>
  </SVGUniqueID>
);

export const Close = () => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 13.975 13.973"
    >
      <path
        id="x"
        d="M18.521,6.344l-5.241,5.24L8.04,6.344,6.293,8.091l5.24,5.24-5.24,5.24L8.04,20.317l5.24-5.24,5.241,5.24,1.747-1.747-5.24-5.24,5.24-5.24Z"
        transform="translate(-6.293 -6.344)"
        fill="#000000"
      ></path>
    </svg>
  </SVGUniqueID>
);
export const ArrowLeft = () => (
  <SVGUniqueID>
    <svg
      className="i-rotate"
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
    >
      <path
        d="M10.735,16.028,12,17.293l6-6-6-6L10.735,6.558l3.84,3.84H6v1.789h8.576Z"
        transform="translate(-6 -5.293)"
        fill="#fff"
      />
    </svg>
  </SVGUniqueID>
);
